import React, { useState } from 'react';
import { Eye, EyeOff, AlertCircle } from 'lucide-react';
interface LoginPageProps {
  onNavigate: (page: string) => void;
}
export function LoginPage({
  onNavigate
}: LoginPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('alexrossi@example.com');
  const [password, setPassword] = useState('password123');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<{
    email?: string;
    password?: string;
    general?: string;
  }>({});
  const validateEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const validate = () => {
    const newErrors: {
      email?: string;
      password?: string;
    } = {};
    if (!email) newErrors.email = "L'email è obbligatoria.";else if (!validateEmail(email)) newErrors.email = 'Inserisci un indirizzo email valido.';
    if (!password) newErrors.password = 'La password è obbligatoria.';
    return newErrors;
  };
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      // Simulate wrong credentials for any email other than the pre-filled one
      if (email !== 'alexrossi@example.com') {
        setErrors({
          general: 'Credenziali non valide. Controlla email e password.'
        });
        return;
      }
      onNavigate('home');
    }, 1000);
  };
  return <div className="min-h-screen bg-green-600 flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-1064">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/wsCbUWp4TF3ni7DwEfb9qP/hand-drawn-turtle-shell-pattern_23-2150598661.jpg)'
    }} data-id="element-1065" />

      <div className="w-full max-w-md relative z-10" data-id="element-1066">
        {/* Logo and Title */}
        <div className="text-center mb-6" data-id="element-1067">
          <div className="inline-block bg-white rounded-2xl p-3 mb-3 shadow-lg" data-id="element-1068">
            <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback Logo" className="h-10 w-auto" data-id="element-1069" />
          </div>
          <h1 className="text-xl font-normal text-white" data-id="element-1070">Accedi a Greenback</h1>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100" data-id="element-1071">
          {/* General error banner */}
          {errors.general && <div className="mb-4 flex items-start gap-2.5 bg-red-50 border border-red-200 rounded-xl px-4 py-3" data-id="element-1072">
              <AlertCircle className="h-4 w-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-1073" />
              <p className="text-xs text-red-700" data-id="element-1074">{errors.general}</p>
            </div>}

          <form onSubmit={handleLogin} className="space-y-4" noValidate data-id="element-1075">
            {/* Email Input */}
            <div className="space-y-1.5" data-id="element-1076">
              <label className="text-sm font-normal text-gray-700 block" data-id="element-1077">
                Email <span className="text-red-500" data-id="element-1078">*</span>
              </label>
              <div className="relative" data-id="element-1079">
                <input type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                setErrors(prev => ({
                  ...prev,
                  email: undefined,
                  general: undefined
                }));
              }} className={`block w-full px-4 py-2.5 border rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:ring-1 transition-colors text-sm ${errors.email ? 'border-red-400 focus:border-red-400 focus:ring-red-400' : 'border-gray-200 focus:border-green-500 focus:ring-green-500'}`} placeholder="alexrossi@example.com" data-id="element-1080" />
              </div>
              {errors.email && <p className="text-xs text-red-500 flex items-center gap-1" data-id="element-1081">
                  <span data-id="element-1082">⚠</span> {errors.email}
                </p>}
            </div>

            {/* Password Input */}
            <div className="space-y-1.5" data-id="element-1083">
              <label className="text-sm font-normal text-gray-700 block" data-id="element-1084">
                Password <span className="text-red-500" data-id="element-1085">*</span>
              </label>
              <div className="relative" data-id="element-1086">
                <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                setPassword(e.target.value);
                setErrors(prev => ({
                  ...prev,
                  password: undefined,
                  general: undefined
                }));
              }} className={`block w-full px-4 py-2.5 border rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:ring-1 transition-colors text-sm ${errors.password ? 'border-red-400 focus:border-red-400 focus:ring-red-400' : 'border-gray-200 focus:border-green-500 focus:ring-green-500'}`} placeholder="••••••••" data-id="element-1087" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1088">
                  {showPassword ? <EyeOff className="h-4 w-4 text-gray-400 hover:text-gray-600" data-id="element-1089" /> : <Eye className="h-4 w-4 text-gray-400 hover:text-gray-600" data-id="element-1090" />}
                </button>
              </div>
              {errors.password && <p className="text-xs text-red-500 flex items-center gap-1" data-id="element-1091">
                  <span data-id="element-1092">⚠</span> {errors.password}
                </p>}
            </div>

            {/* Remember Me and Forgot Password */}
            <div className="flex items-center justify-between" data-id="element-1093">
              <label className="flex items-center cursor-pointer" data-id="element-1094">
                <input type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500 cursor-pointer" data-id="element-1095" />
                <span className="ml-2 text-xs text-gray-700" data-id="element-1096">Ricordami</span>
              </label>
              <button type="button" onClick={() => onNavigate('forgot-password')} className="text-xs text-green-600 hover:text-green-700 font-normal" data-id="element-1097">
                Password dimenticata?
              </button>
            </div>

            {/* Login Button */}
            <button type="submit" disabled={isLoading} className="w-full flex items-center justify-center py-3 px-4 rounded-full shadow-sm text-sm font-normal text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-1098">
              {isLoading ? <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1099" /> : 'Accedi'}
            </button>
          </form>

          {/* Divider */}
          <div className="mt-5" data-id="element-1100">
            <div className="relative" data-id="element-1101">
              <div className="absolute inset-0 flex items-center" data-id="element-1102">
                <div className="w-full border-t border-gray-200" data-id="element-1103" />
              </div>
              <div className="relative flex justify-center text-xs" data-id="element-1104">
                <span className="px-2 bg-white text-gray-400" data-id="element-1105">
                  Oppure accedi con
                </span>
              </div>
            </div>
          </div>

          {/* Social Login Buttons — disabled, Prossimamente */}
          <div className="mt-4 space-y-2.5" data-id="element-1106">
            <div className="space-y-1" data-id="element-1107">
              <button type="button" disabled className="w-full flex items-center justify-center gap-2.5 py-2.5 px-4 border border-gray-100 rounded-xl text-xs font-normal text-gray-300 bg-gray-50 cursor-not-allowed" data-id="element-1108">
                <svg className="h-4 w-4 opacity-40" viewBox="0 0 24 24" data-id="element-1109">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-1110" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-1111" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-1112" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-1113" />
                </svg>
                Google Workspace
              </button>
              <p className="text-center text-[10px] text-gray-400" data-id="element-1114">
                Prossimamente
              </p>
            </div>

            <div className="space-y-1" data-id="element-1115">
              <button type="button" disabled className="w-full flex items-center justify-center gap-2.5 py-2.5 px-4 border border-gray-100 rounded-xl text-xs font-normal text-gray-300 bg-gray-50 cursor-not-allowed" data-id="element-1116">
                <svg className="h-4 w-4 opacity-40" viewBox="0 0 23 23" data-id="element-1117">
                  <path fill="#f3f3f3" d="M0 0h23v23H0z" data-id="element-1118" />
                  <path fill="#f35325" d="M1 1h10v10H1z" data-id="element-1119" />
                  <path fill="#81bc06" d="M12 1h10v10H12z" data-id="element-1120" />
                  <path fill="#05a6f0" d="M1 12h10v10H1z" data-id="element-1121" />
                  <path fill="#ffba08" d="M12 12h10v10H12z" data-id="element-1122" />
                </svg>
                Microsoft 365
              </button>
              <p className="text-center text-[10px] text-gray-400" data-id="element-1123">
                Prossimamente
              </p>
            </div>
          </div>

          {/* Sign Up Link */}
          <div className="mt-5 text-center" data-id="element-1124">
            <p className="text-xs text-gray-600" data-id="element-1125">
              Non hai un account?{' '}
              <button type="button" onClick={() => onNavigate('signup')} className="text-green-600 hover:text-green-700 font-normal" data-id="element-1126">
                Registrati
              </button>
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-white/80 mt-4" data-id="element-1127">
          © 2026 Greenback. Tutti i diritti riservati.
        </p>
      </div>
    </div>;
}